export class AppFile  { 
 
  id: number;
  fileName: string;
  fileTypeId: number;
  fileTypeName: string;
  fileShortDescription: string;
  fileLongDescription: string;
  uploadById: number;
  uploadByName: number;
  uploadDate: Date;
  filePath: string;
  rawFile: string;
  requestId: number;

  //  lastModifiedDate: any;
  //  name: string;
  //  webkitRelativePath: string;
  //  size: number;
  //  type: string;
   
  //  msClose(): void {
  //    throw new Error("Method not implemented.");
  //  }
  //  msDetachStream() {
  //    throw new Error("Method not implemented.");
  //  }
  //  slice(start?: number, end?: number, contentType?: string): Blob {
  //    throw new Error("Method not implemented.");
  //  }
}



// WEBPACK FOOTER //
// ./src/app/core/models/app-file.ts